

export enum AppLayoutMode {

    FitToBrowser,
    FitToContent

}